import {
  BanknotesIcon,
  BuildingOfficeIcon,
  CubeIcon,
  CurrencyDollarIcon,
  DocumentChartBarIcon,
  DocumentDuplicateIcon,
  DocumentTextIcon,
  MapIcon,
  MapPinIcon,
  NewspaperIcon,
  RectangleGroupIcon,
  TableCellsIcon,
  UserGroupIcon,
} from '@heroicons/react/24/solid';

export const widgetsIcon: { [key: string]: React.ReactNode } = {
  REBUILD_INVENTORY: <DocumentDuplicateIcon className='h-5 w-5' />,
  REBUILD_LOANS_APPROVED: <CubeIcon className='h-5 w-5' />,
  TOTAL_DEVELOPERS: <UserGroupIcon className='h-5 w-5' />,
  TOTAL_PROJECTS: <BuildingOfficeIcon className='h-5 w-5' />,
  PROJECT_LOCATION: <MapPinIcon className='h-5 w-5' />,
  PROJECTS_BY_NEIGHBORHOOD: <MapIcon className='h-5 w-5' />,
  PROJECT_BUDGET_SUMMARY: <BanknotesIcon className='h-5 w-5' />,
  PROJECT_FINANCIAL: <CurrencyDollarIcon className='h-5 w-5' />,
  PROJECT_STATUS_SUMMARY: <NewspaperIcon className='h-5 w-5' />,
  PROJECTS_BY_PROJECT_TYPE: <BuildingOfficeIcon className='h-5 w-5' />,
  PROJECTS_BY_CONSTRUCTION_TYPE: <RectangleGroupIcon className='h-5 w-5' />,
  TASKS_COUNT: <TableCellsIcon className='h-5 w-5' />,
  DELIVERABLES_COUNT: <DocumentTextIcon className='h-5 w-5' />,
  MILESTONES_COUNT: <DocumentChartBarIcon className='h-5 w-5' />,
};
